import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSettings } from '../context/SettingsContext'

const Checkout = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cart, setCart] = useState([]);
    const [estimatDate, setEstimatDate] = useState(null)
    const { settings } = useSettings();
    const shipping = settings?.shipping_rate;

    const [orders, setOrders] = useState({
        user_id: JSON.parse(localStorage.getItem("user"))?.id || null,
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        company: "",
        address1: "",
        address2: "",
        state: "",
        zip: "",
        country: "",
        town: "",
        order_note: "",
        payment_status: "pending",
        stripe_charge_id: "",
        estimatDate: "",
        order_summary: {
            subtotal: 0,
            total: 0,
            shipping: 0,
            tax: 0
        },
        ordered_products: [],
    });

    useEffect(() => {
        const data = localStorage.getItem("cart");
        if (data) {
            try {
                const parsed = JSON.parse(data);
                setCart(parsed);

                const subtotal = parsed.reduce(
                    (acc, item) => acc + item.price * item.quantity,
                    0
                );
                const shipping = 9.99;
                const total = subtotal + shipping;
                setOrders((prev) => ({
                    ...prev,
                    order_summary: { subtotal, total, shipping, tax: 0 },
                    ordered_products: parsed.map((item) => ({
                        cart: {
                            id: item.ProductCode,
                            name: item.name,
                            image: item.image,
                            price: item.price,
                            quantity: item.quantity,
                        },
                    })),

                }));
            } catch (error) {
                console.error("Invalid cart data", error);
            }
        }
    }, []);

    useEffect(() => {
        if (cart.length > 0) handleOrderEnquiry();
    }, [cart]);

    useEffect(() => {
        if (estimatDate) {
            setOrders((prev) => ({
                ...prev,
                estimatDate: estimatDate,
            }));
        }
    }, [estimatDate]);

    const total = cart.reduce(
        (acc, item) => acc + item.price * (item.quantity || 1),
        0
    );

    const handleChange = (e) => {
        setOrders({ ...orders, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        if (!orders.first_name?.trim()) return "First Name is required";
        if (!orders.last_name?.trim()) return "Last Name is required";
        if (!/\S+@\S+\.\S+/.test(orders.email)) return "Enter a valid Email address";
        if (!orders.phone?.trim()) return "Phone Number is required";
        if (!orders.address1?.trim()) return "Shipping Address is required";
        if (!orders.country?.trim()) return "Country is required";
        if (!orders.town?.trim()) return "City is required";
        const ukPostcodeRegex = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i;
        if (!ukPostcodeRegex.test(orders.zip)) {
            return "Please enter a valid UK postcode (e.g., EC1A 1BB)";
        }
        return true;
    };

    const handleOrderEnquiry = async () => {
        setLoading(true);
        try {
            const enquiry = await axios.post(
                `${process.env.REACT_APP_API_URL}call-third-party`,
                {
                    url: `${process.env.REACT_APP_BOND_API_URL}WService=BondWSLive/SWDB/jgat0000.w`,
                    body: {
                        Event: "order_enquiry",
                        UserId: "MV00008",
                        APIKey: "bFjncidncrcbElCm",
                        CustomerInformation: {
                            AccountNumber: "MV00008",
                            TradingPoint: "BI01",
                        },
                        DeliveryMethod: "Deliver",
                        Items: cart.map((item, index) => ({
                            LineRef: index + 1,
                            ProductCode: item.ProductCode,
                            RequestedQty: item.quantity,
                        })),
                    },
                }
            );

            const status = enquiry?.data?.data?.Response?.Status;
            if (status === "Success") {
                toast.success(
                    `Estimated Delivery: ${enquiry?.data?.data?.Response?.EstimatedDeliveryDate}`
                );
                setEstimatDate(enquiry?.data?.data?.Response?.EstimatedDeliveryDate)
            } else {
                toast.error(
                    enquiry?.data?.data?.Response?.ErrorDescription ||
                    "Order enquiry failed."
                );
            }
        } catch (error) {
            console.error("Order Enquiry Error:", error);
            toast.error("Order enquiry failed. Please refresh and try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validation = validateForm();
        if (validation !== true) {
            toast.error(validation);
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}save-order`, orders);
            if (res.data.code === 200 && res.data.status === true) {
                const orderNumber = res.data?.data?.order_number;
                toast.success("Order saved. Redirecting to payment...");
                localStorage.setItem("orders", JSON.stringify(orders));
                // localStorage.setItem("cart", JSON.stringify(cart));
                // localStorage.setItem("total", total);
                setTimeout(() => {
                    navigate("/payment",
                        {
                            state:
                            {
                                orders,
                                orderNumber,
                                cart,
                                total
                            }
                        });
                }, 1000);
            }
        } catch (err) {
            console.error("Order Save Error:", err);
            toast.error("Failed to save order. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="inner-banner-left">
                                <h1>Checkout</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>

            <section className="checkout_page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8 col-12">
                            <div className="billing_form wow fadeInLeftBig" data-wow-duration="2s">
                                <h3>Billing Details</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label>First Name*</label>
                                            <input
                                                type="text"
                                                name="first_name"
                                                value={orders.first_name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Last Name*</label>
                                            <input
                                                type="text"
                                                name="last_name"
                                                value={orders.last_name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Email*</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={orders.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Phone*</label>
                                            <input
                                                type="text"
                                                name="phone"
                                                value={orders.phone}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Shipping Address*</label>
                                            <input
                                                type="text"
                                                name="address1"
                                                value={orders.address1}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Shipping Address (Optional)*</label>
                                            <input
                                                type="text"
                                                name="address2"
                                                value={orders.address2}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Country*</label>
                                            <input
                                                type="text"
                                                name="country"
                                                value={orders.country}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>City*</label>
                                            <input
                                                type="text"
                                                name="town"
                                                value={orders.town}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>County (Optional)</label>
                                            <input
                                                type="text"
                                                name="state"
                                                value={orders.state}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Postal Code*</label>
                                            <input
                                                type="text"
                                                name="zip"
                                                placeholder="e.g., EC1A 1BB"
                                                value={orders.zip}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Order Notes (Optional)*</label>
                                            <textarea
                                                name="order_note"
                                                value={orders.order_note}
                                                onChange={handleChange}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="check-out-btn">
                                        <button
                                            className="theme-btn"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? "Processing..." : "Confirm Order"}
                                            <span>
                                                <img
                                                    src="images/arrow-right.png"
                                                    alt="icon"
                                                    style={{ marginLeft: 8 }}
                                                />
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div
                            className="col-lg-4 col-md-4 col-12"
                            data-aos="flip-right"
                            data-aos-duration={1000}
                        >
                            <div className="cart_sidebar wow fadeInRightBig">
                                <h3>Your Order</h3>
                                <ul className="cart_lst">
                                    {cart.length > 0 ? (
                                        cart.map((item, i) => (
                                            <li key={i}>
                                                <img src={item.image} alt="" />
                                                <p>{item.name} <strong>x {item.quantity}</strong></p>
                                                <span>£{(item.price * item.quantity).toFixed(2)}</span>
                                            </li>
                                        ))
                                    ) : (
                                        <li>No items in cart</li>
                                    )}
                                </ul>
                                <ul className="cart_lst carttwoList">
                                    {
                                        estimatDate !== null ? <li><strong>Estimated Delivery</strong> <span>{estimatDate}</span></li> : false
                                    }
                                    <li><strong>Shipping</strong> <span>£{shipping?.toFixed(2)}</span></li>
                                    <li>
                                        <strong>Total</strong>{" "}
                                        <span>£{(total + shipping).toFixed(2)}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Checkout;
